import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, updateDoc, where, query } from 'firebase/firestore';
import { db } from '../config/firebase';

const spendTypesCollection = collection(db, "spend_types");

const spendTypeService = {
  getAll: async () => {
    try {
      const spendTypesSnapshot = await getDocs(spendTypesCollection);
      const spendTypesList = spendTypesSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return spendTypesList;
    } catch (error) {
      console.error('Error fetching spend Types:', error);
      throw error;
    }
  },
  add: async (spendTypesData) => {
    try {
      const docRef = await addDoc(spendTypesCollection, spendTypesData);
      return docRef;
    } catch (error) {
      console.error('Error adding spend Type:', error);
      throw error;
    }
  },
  edit: async ({ id, data }) => {
    try {
      const spendTypeRef = doc(db, 'spend_types', id);
      await updateDoc(spendTypeRef, data);
    } catch (error) {
      console.error('Error updating spend Type:', error);
      throw error;
    }
  },
  delete: async (spendTypeId) => {
    try {
      await deleteDoc(doc(db, "spend_types", spendTypeId));
      return true;
    } catch (error) {
      console.error('Error deleting spend Type:', error);
      throw error;
    }
  },

  getNameById: async (spendTypeId) => {
    try {
      const spendTypeRef = doc(db, 'spend_types', spendTypeId);
      const spendTypeSnap = await getDoc(spendTypeRef);

      if (spendTypeSnap.exists()) {
        return spendTypeSnap.data().name;
      }
      else {
        return null;
      }
    }
    catch (error) {
      console.error('Error getting spend Type name:', error);
      throw error;
    }
  },
  geteventTypeSpendTypes: async (EventTypeId) => {
    try {
      const querySnapshot = await getDocs(
        query(spendTypesCollection, where("event_type_id", "==", EventTypeId))
      );

      const spendTypes = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      return spendTypes;
    } catch (error) {
      console.error("Error getting Spend Types:", error);
      throw error;
    }
  }
};

export default spendTypeService;